import React from 'react'
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatNumber, formatPercent } from '../../../utilities/dashboard'
import ChartTooltip, { BarLabel } from './ChartTooltip'
import { ACTIVE_BAR, axisTick, CHART_DESC } from './DailyChart'
import useChartColors from './useChartColors'

// Faixa etária: faixas em ordem, numa rampa de um matiz só (a cor também mostra a ordem). O número fica na ponta
// de cada barra: a faixa mais clara tem pouco contraste com o fundo
const AgeChart = ({ rows, totalWithBirth, narrow, title }) => {
  const { chart: colors } = useChartColors()
  // No celular, "60–69" e "70+" para os rótulos não encostarem
  const tickLabel = (label) => (narrow ? label.replace(' a ', '–').replace(' ou mais', '+') : label)

  const tooltipFor = (row) => ({
    title: `${row.label} anos`,
    rows: [{ color: row.color, value: formatNumber(row.total), label: row.total === 1 ? 'paciente' : 'pacientes' }],
    notes: [totalWithBirth ? `${formatPercent((row.total / totalWithBirth) * 100)} dos que têm data de nascimento` : ''],
  })

  return (
    <ResponsiveContainer width='100%' height={240}>
      <BarChart data={rows} margin={{ top: 18, right: 8, bottom: 0, left: -10 }} accessibilityLayer title={title} desc={CHART_DESC}>
        <CartesianGrid vertical={false} stroke={colors.grid} />
        <XAxis dataKey='label' interval={0} tickFormatter={tickLabel} tickLine={false} axisLine={{ stroke: colors.axis }} tick={axisTick(colors)} />
        <YAxis allowDecimals={false} width={44} tickLine={false} axisLine={false} tick={axisTick(colors)} />
        <Tooltip cursor={{ fill: colors.cursor }} content={<ChartTooltip render={tooltipFor} />} isAnimationActive={false} />
        <Bar dataKey='total' name='Pacientes' radius={[4, 4, 0, 0]} maxBarSize={24} activeBar={ACTIVE_BAR} isAnimationActive={false}>
          {rows.map((row) => <Cell key={row.label} fill={row.color} />)}
          <LabelList dataKey='total' formatter={formatNumber} content={<BarLabel />} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default AgeChart
